import { createRoot, hydrateRoot } from 'react-dom/client'
import App from './App.tsx'
import { appRoutes } from './routes'
import './index.css'

const container = document.getElementById("root")!;

function currentRoute() {
  const raw = window.location.pathname;
  const normalized = raw.length > 1 ? raw.replace(/\/+$/, "") : raw;
  return appRoutes.find((r) => r.path === normalized || r.path === raw);
}

// Prerendered routes (see scripts/prerender.mjs) ship real markup — hydrate it.
// The route chunk is loaded BEFORE hydration so the first client render matches
// the server markup exactly (no Suspense fallback swap, no hydration mismatch).
if (container.hasChildNodes()) {
  const route = currentRoute();
  if (route) {
    route.importer().then((mod) => {
      hydrateRoot(
        container,
        <App preloadedPath={route.path} PreloadedComponent={mod.default} />
      );
    });
  } else {
    hydrateRoot(container, <App />);
  }
} else {
  createRoot(container).render(<App />);
}
